import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { LogReajusteContratoFinanceiro } from "../../../../domain/models/log_reajuste_contrato_financeiro";
import { GenerateLogReajusteContratoFinanceiroColumns } from "../columns/log_reajuste_contrato_financeiro";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TablePagination } from "@mui/material";


type props = {
    open: boolean,
    loading: boolean,
    logReajusteContratoFinanceiroLista: LogReajusteContratoFinanceiro[] | [],
    totalItems: number,
    page: number,
    rowsPerPage: number,
    handlePageChange: (page: number) => void,
    handleRowsPerPageChange: (rowsPerPage: number) => void,
    onClose: () => void,
}

export const LogReajusteContratoFinanceiroModal = ({
    open,
    loading,
    logReajusteContratoFinanceiroLista,
    totalItems,
    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    onClose,

}: props) => {

    const columnsDef = useMemo(() => {
        return GenerateLogReajusteContratoFinanceiroColumns();
    }, []);


    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "60rem",
                    },
                },
            }}>

            <DialogTitle>
                Historico de Reajustes do Contrato
            </DialogTitle>

            <DialogContent>
                <>
                    <Stack spacing={0}>
                        <div className="w-full flex flex-row justify-between items-stretch">
                            <div className="flex flex-col justify-between flex-1">
                                <TablePagination
                                    component="div"
                                    count={totalItems}
                                    page={page - 1}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    onPageChange={(_, p) => handlePageChange(p)}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={(e) => handleRowsPerPageChange(parseInt(e.target.value))} />
                            </div>
                        </div>

                        <StyledDataGrid
                            tableName="LogReajusteContratoFinanceiro_Lista"
                            disableColumnMenu={false}
                            showToolbar={true}
                            disableRowSelectionOnClick={true}
                            getRowId={(row: LogReajusteContratoFinanceiro) => row.idLogReajusteContratoFinanceiro}
                            columns={columnsDef}
                            loading={loading}
                            checkboxSelection={false}
                            rows={logReajusteContratoFinanceiroLista}
                            rowCount={logReajusteContratoFinanceiroLista.length}
                            pageSizeOptions={[10, 25, 50, 100]}
                            paginationMode="server"
                            paginationModel={{
                                page: 1,
                                pageSize: 50,
                            }}

                        />


                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page - 1}
                            onPageChange={(_, p) => handlePageChange(p)}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => handleRowsPerPageChange(parseInt(e.target.value))}
                        />

                    </Stack>
                </>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">
                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={onClose}>
                                Cancelar
                            </h1>
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}